import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import Chatbot from "./components/site/Chatbot";
import SmoothScroll from "./components/site/SmoothScroll";
import ScrollToTop from "./components/site/ScrollToTop";
import ErrorBoundary from "./components/site/ErrorBoundary";

import Home from "./pages/Home";
import About from "./pages/About";
import Subsidiaries from "./pages/Subsidiaries";
import SubsidiaryDetail from "./pages/SubsidiaryDetail";
import VeteranHousing from "./pages/VeteranHousing";
import Realty from "./pages/Realty";
import Investors from "./pages/Investors";
import Club220 from "./pages/Club220";
import Foundation from "./pages/Foundation";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Education from "./pages/Education";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import PortalHub from "./pages/PortalHub";
import AdminPanel from "./components/portals/AdminPanel";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import InvestorPortal from "./components/portals/InvestorPortal";
import { ResidentPortal, TenantPortal, ContractorPortal } from "./components/portals/RoleDashboards";

import "./index.css";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SmoothScroll />
          <div className="min-h-screen bg-[#0A0A0A]">
            <Navbar />
            <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/subsidiaries" element={<Subsidiaries />} />
              <Route path="/subsidiaries/:slug" element={<SubsidiaryDetail />} />
              <Route path="/veteran-housing" element={<VeteranHousing />} />
              <Route path="/realty" element={<Realty />} />
              <Route path="/investors" element={<Investors />} />
              <Route path="/club-220" element={<Club220 />} />
              <Route path="/foundation" element={<Foundation />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/education" element={<Education />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/portal" element={<PortalHub />} />
              <Route path="/portal/admin" element={<AdminPanel />} />
              <Route path="/portal/admin/:tab" element={<AdminPanel />} />
              <Route path="/portal/investor" element={<InvestorPortal />} />
              <Route path="/portal/resident" element={<ResidentPortal />} />
              <Route path="/portal/tenant" element={<TenantPortal />} />
              <Route path="/portal/contractor" element={<ContractorPortal />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
            <Footer />
            <Chatbot />
            <Toaster position="top-right" theme="dark" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
